/* eslint-disable @typescript-eslint/no-var-requires */
const marketAvailability = require('../../oneweb.market-availability.js');
const packageMeta = require('./package.json');
const seamlessRc = require('./../../.seamlessrc.json');

const NAME = 'stage-campaign-item';
const TENANT = seamlessRc.tenantId;
const pluginPath = `/${TENANT}-${NAME}/${TENANT}-${NAME}-${packageMeta.version}`;
const fileName = NAME;

module.exports = {
  manifestVersion: '2.0',
  name: `${TENANT}-${NAME}`,
  version: packageMeta.version,
  config: {
    hasCss: false,
    files: {
      scripts: [
        {
          url: `${pluginPath}/vendors~app.${fileName}.min.js`,
          attrs: {
            type: 'module', // vendor
          },
        },
        {
          url: `${pluginPath}/${fileName}.min.js`,
          attrs: {
            type: 'module', // component
          },
        },
      ],
      styles: [
        {
          url: `${pluginPath}/${TENANT}-${NAME}.css`,
        },
      ],
    },
    dependencies: {
      oneweb: '2.0',
    },
    isUserSessionRequired: false,
    integrationType: 'webcomponent',
    marketAvailability,
  },
  aemComponentConfig: {
    title: 'emh stage-campaign-item Web Component',
    description: packageMeta.description,
    componentGroup: 'Generic NG - Content',
    productPrefix: seamlessRc.tenantId,
    tagNameWithoutPrefix: 'stage-campaign-item',
    dialog: [
      {
        widgetType: 'checkbox',
        label: 'Hide item',
        param: 'hide',
      },
      {
        widgetType: 'text',
        label: 'Headline',
        param: 'headline',
        translatable: true,
      },
      {
        widgetType: 'text',
        label: 'Description',
        param: 'description',
        translatable: true,
      },
      {
        widgetType: 'dropdown',
        param: 'theme',
        label: 'Theme (Light/Dark)',
        options: [
          {
            label: 'light',
            value: 'light',
            selected: true,
          },
          {
            label: 'dark',
            value: 'dark',
          },
        ],
      },
      {
        widgetType: 'dropdown',
        param: 'horizontalAlign',
        label: 'Horizontal alignment',
        hint: 'Horizontal positioning of text and buttons',
        options: [
          {
            label: 'left',
            value: 'left',
            selected: true,
          },
          {
            label: 'center',
            value: 'center',
          },
          {
            label: 'right',
            value: 'right',
          },
        ],
      },
      {
        widgetType: 'dropdown',
        param: 'verticalAlign',
        label: 'Vertical alignment',
        hint: 'Vertical positioning of text',
        options: [
          {
            label: 'top',
            value: 'top',
          },
          {
            label: 'middle',
            value: 'middle',
            selected: true,
          },
          {
            label: 'bottom',
            value: 'bottom',
          },
        ],
      },
      {
        widgetType: 'text',
        label: 'Analytics Campaign',
        param: 'analytics',
      },
      {
        widgetType: 'checkbox',
        label: 'Show campaign tag',
        param: 'showCampaignTag',
      },
      {
        widgetType: 'text',
        label: 'Campaign tag label',
        param: 'campaignTagLabel',
      },
      {
        widgetType: 'tab',
        label: 'Buttons',
        param: 'tab1',
        elements: [
          {
            widgetType: 'text',
            label: 'CTA 1 label',
            param: 'ctaLabel',
            required: false,
            translatable: true,
          },
          {
            widgetType: 'link',
            label: 'CTA 1 link',
            param: 'ctaLink',
            required: false,
            hint: '`sort` param is required to show prices in this component. Examples: standalone SPA - .../srp?sort=price-asc..., AEM - .../search-results.html/?emhsort=price-asc...',
          },
          {
            widgetType: 'text',
            label: 'CTA 2 label',
            param: 'secondaryLabel',
            required: false,
            translatable: true,
          },
          {
            widgetType: 'link',
            label: 'CTA 2 link',
            param: 'secondaryLink',
            required: false,
          },
        ],
      },
      {
        widgetType: 'tab',
        label: 'Images',
        param: 'tabImages',
        elements: [
          {
            widgetType: 'asset',
            label: 'Image MQ 4-6',
            param: 'imageUrl',
            mimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
            required: true,
          },
          {
            widgetType: 'asset',
            label: 'Image MQ 3',
            param: 'imageUrlMid',
            mimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
            required: true,
          },
          {
            widgetType: 'asset',
            label: 'Image MQ 1-2',
            param: 'imageUrlSmall',
            mimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
            required: true,
          },
        ],
      },
    ],
  },
};
